import { useVModel } from "@vueuse/core";
import { defineComponent } from "vue";
import BrandLogo from "./components/features/BrandLogo";
import LocaleSwitcher from "./components/features/locale-switcher/LocaleSwitcher";
import ThemeSwitcher from "./components/features/theme-switcher/ThemeSwitcher";
import H4 from "./components/typography/H4";
import P from "./components/typography/P";
import Button from "./components/ui/button/Button";
import { $t } from "./services/i18n";
import { browserSupportForHasSelector } from "./utils/browser-support";
import { objectEntries } from "./utils/object";

export default defineComponent({
  name: "BrowserNotSupported",
  props: {
    browser: String,
    actualVersion: String,
    minimumVersion: String,
    dismiss: Boolean,
  },
  setup(props) {
    const dismiss = useVModel(props, "dismiss");
    const browserOptions = objectEntries(browserSupportForHasSelector).reduce(
      (acc, [browser, version], index, arr) => {
        if (version === null || props.browser === browser) return acc;

        const browserVersion = `${browser} ≥ ${version}`;
        if (index === arr.length - 1) {
          return `${acc} ou ${browserVersion}`;
        } else {
          return `${acc}, ${browserVersion}`;
        }
      },
      ""
    );

    return () => (
      <div class="center h-screen">
        <div class="absolute right-6 top-5">
          <LocaleSwitcher />
          <ThemeSwitcher />
        </div>
        <div class="max-w-lg rounded border p-6">
          <BrandLogo class="mx-auto mb-8 h-12 text-balance" />
          <H4 class="text-center leading-none">{$t("browser_not_supported.title")}</H4>
          <P>
            {$t("browser_not_supported.greeting")}{" "}
            <strong class="font-bold">
              {props.browser} {$t("browser_not_supported.version")} {props.actualVersion}
            </strong>
            . {$t("browser_not_supported.recommendation")}{" "}
            <strong class="font-bold">Versão {props.minimumVersion} </strong> ou superior.
          </P>
          <P>
            {$t("browser_not_supported.supported_browsers")}: {browserOptions}.
          </P>
          <P>{$t("browser_not_supported.warning")}</P>
          <div class="center mt-6">
            <Button
              onClick={() => {
                dismiss.value = true;
              }}
            >
              {$t("browser_not_supported.continue_button")}
            </Button>
          </div>
          <P>{$t("browser_not_supported.thanks")}</P>
        </div>
      </div>
    );
  },
});
